/**
 * Created by Alex Xia on 12/17/2018.
 * Description:
 * Add contact page
 * ------ maintenance history ------
 *  05/05/2019 Yoyo change to support embedded mode data soure changed by config.actionSubject$
 * 05/10/2019 Alex moved the logics to contact screen component
 */
import { Component, OnInit } from '@angular/core';
import { ContactConfig } from './contact.model';

@Component({
    selector: 'tam-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    contactScreenConfig: ContactConfig;
    constructor(
    ) { }

    ngOnInit() {
        this.contactScreenConfig = new ContactConfig(false);
    }
}
